<!--
  Pointer events cover mouse, touch and pen; a press that travels less than the
  threshold is still a click (`activated`). The three release events all end
  the gesture — the first to arrive does the work — and the arrow keys give
  keyboard users the same travel. Icon and badge come from the host.
-->
<button
  #fab
  type="button"
  class="fab btn btn-primary"
  [attr.aria-label]="ariaLabel"
  (pointerdown)="onPointerDown($event)"
  (pointerup)="onPointerRelease()"
  (pointercancel)="onPointerRelease()"
  (lostpointercapture)="onPointerRelease()"
  (click)="onClick()"
  (keydown.arrowUp)="onArrowKey($event, 'up')"
  (keydown.arrowDown)="onArrowKey($event, 'down')"
>
  <ng-content></ng-content>
</button>
